import * as React from "react";

export const IconSend = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2.5 16.6663L2.5 11.6663L9.16667 9.99967L2.5 8.33301L2.5 3.33301L18.3333 9.99967L2.5 16.6663Z" fill="currentColor" />
  </svg>
);
